import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatTableModule } from "@angular/material/table";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslateModule } from "@ngx-translate/core";

import { PickerModule } from "@ctrl/ngx-emoji-mart";

import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { FuseSharedModule } from "@fuse/shared.module";

import { ActionPlanComponent } from "./action-plan/action-plan.component";
import { ComentarComponent } from "./comentar/comentar.component";
import { ItemCommentComponent } from "./comentar/item-comment/item-comment.component";
import { ComunicacionMensajeComponent } from "./comunicacion-mensaje/comunicacion-mensaje.component";
import { TimeControlAmpliadoComponent } from "./time-control-ampliado/time-control-ampliado.component";
import { TimeControlIncidenciaComponent } from "./time-control-incidencia/time-control-incidencia.component";
import { TimeControlComponent } from "./time-control/time-control.component";
import { TiposEntradaComponent } from "./tipos-entrada/tipos-entrada.component";

import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDividerModule } from "@angular/material/divider";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatStepperModule } from "@angular/material/stepper";
import { DateRangeInputComponent } from "app/admin/components/date-range-input/date-range-input.component";
import { DateFormatDirective } from "app/directives/date-format.directive";
import { NgxDaterangepickerMd } from "ngx-daterangepicker-material";
import { ImageCropperComponent } from "ngx-image-cropper";
import { ActionPlanBlueComponent } from "./action-plan-blue/action-plan-blue.component";
import { DialogSolicitarModificacionComponent } from "./action-plan-blue/dialog-solicitar-modificacion/dialog-solicitar-modificacion.component";
import { TransferDialogComponent } from "./action-plan/transfer-dialog/transfer-dialog.component";
import { CompetencyComponent } from "./competency-dialog/competency.component";
import { DialogDetallesAusenciaComponent } from "./dialog-detalles-ausencia/dialog-detalles-ausencia.component";
import { DialogShowIncidencia } from "./dialog-show-incidencia/dialog-show-incidencia.component";
import { DialogTimeResumenComponent } from "./dialog-time-resumen/dialog-time-resumen.component";
import { EmojiPickerComponent } from "./emoji-picker/emoji-picker.component";
import { EvaluationCommentComponent } from "./evaluation-comment/evaluation-comment.component";
import { DialogCarouselComponent } from "./image-documents-carousel/dialog-carousel/dialog-carousel.component";
import { ImagenDocumentCarouselComponent } from "./image-documents-carousel/image-documents-carousel.component";
import { ImageSelectorComponent } from "./image-selector/image-selector.component";
import { ItemPostProComponent } from "./item-post-pro/item-post-pro.component";
import { KpiDataComponent } from "./kpi-data/kpi-data.component";
import { MediaDialogComponent } from "./media-dialog/media-dialog.component";
import { TandemCalendarComponent } from "./tandem-calendar/tandem-calendar.component";
import { TiposPausaComponent } from "./tipos-pausa/tipos-pausa.component";
import { VacationCalendarPersonComponent } from "./vacation-calendar-person/vacation-calendar-person.component";
import { VacationCalendarComponent } from "./vacation-calendar/vacation-calendar.component";

import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { CalendarModule, DateAdapter } from "angular-calendar";
import { adapterFactory } from "angular-calendar/date-adapters/date-fns";
import { DialogNotasEvaluacionComponent } from "app/main/evaluacion/dialog-notas-evaluacion/dialog-notas-evaluacion.component";
import { NewRestrictedComponent } from "app/main/vacaciones-incidencias/incidencias/new/newRestricted/newRestricted.component";
import { TipoIncidenciaAditionalInfoDialogComponent } from "app/main/vacaciones-incidencias/incidencias/new/newRestricted/tipo-incidencia/tipo-incidencia-aditional-info-dialog.component";
import { AngularCalendarComponent } from "./angular-calendar/angular-calendar.component";
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TranslateModule,
        MatButtonModule,
        MatIconModule,
        MatCardModule,
        MatListModule,
        MatFormFieldModule,
        MatInputModule,
        MatDialogModule,
        MatTooltipModule,
        MatSnackBarModule,
        MatToolbarModule,
        MatTableModule,
        FontAwesomeModule,
        MatDatepickerModule,
        MatStepperModule,
        MatSelectModule,
        MatSlideToggleModule,
        PickerModule,
        MatCheckboxModule,
        MatMenuModule,
        MatPaginatorModule,
        MatProgressSpinnerModule,

        FuseSharedModule,
        ImageCropperComponent,
        MediaDialogComponent,
        CalendarModule.forRoot({
            provide: DateAdapter,
            useFactory: adapterFactory
        }),
        NgxDaterangepickerMd.forRoot()
    ],
    declarations: [
        AngularCalendarComponent,
        ComunicacionMensajeComponent,
        ComentarComponent,
        ItemCommentComponent,
        TimeControlComponent,
        TimeControlAmpliadoComponent,
        TimeControlIncidenciaComponent,
        TiposEntradaComponent,
        TiposPausaComponent,
        VacationCalendarComponent,
        CompetencyComponent,
        KpiDataComponent,
        ActionPlanComponent,
        EvaluationCommentComponent,
        VacationCalendarPersonComponent,
        EmojiPickerComponent,
        DateRangeInputComponent,
        DateFormatDirective,
        TransferDialogComponent,
        ImageSelectorComponent,
        TandemCalendarComponent,
        DialogCarouselComponent,
        DialogTimeResumenComponent,
        ImagenDocumentCarouselComponent,
        ItemPostProComponent,
        ActionPlanBlueComponent,
        DialogSolicitarModificacionComponent,
        DialogShowIncidencia,
        DialogDetallesAusenciaComponent,
        DialogNotasEvaluacionComponent,
        NewRestrictedComponent,
        TipoIncidenciaAditionalInfoDialogComponent
    ],
    exports: [
        ComunicacionMensajeComponent,
        ComentarComponent,
        ItemCommentComponent,
        TimeControlComponent,
        TimeControlAmpliadoComponent,
        TimeControlIncidenciaComponent,
        TiposEntradaComponent,
        TiposPausaComponent,
        VacationCalendarComponent,
        CompetencyComponent,
        KpiDataComponent,
        ActionPlanComponent,
        EvaluationCommentComponent,
        VacationCalendarPersonComponent,
        EmojiPickerComponent,
        MatIconModule,
        MatButtonModule,
        MatDividerModule,
        MatTableModule,
        MatSlideToggleModule,
        DateFormatDirective,
        MatStepperModule,
        DateRangeInputComponent,
        NgxDaterangepickerMd,
        ImageSelectorComponent,
        TandemCalendarComponent,
        DialogCarouselComponent,
        ImagenDocumentCarouselComponent,
        ItemPostProComponent,
        ActionPlanBlueComponent,
        DialogShowIncidencia,
        DialogDetallesAusenciaComponent,
        AngularCalendarComponent,
        DialogNotasEvaluacionComponent,
        NewRestrictedComponent
    ]
})
export class SharedComponentsModule {}
